import { render, staticRenderFns } from "./CaseStack.vue?vue&type=template&id=4fec66bf"
import script from "./CaseStack.vue?vue&type=script&lang=ts"
export * from "./CaseStack.vue?vue&type=script&lang=ts"
import style0 from "./CaseStack.vue?vue&type=style&index=0&id=4fec66bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports